import React from 'react';
import SMStream from 'dash-front/components/sm/streams/SMStream2';
import { connect } from 'react-redux';
import _ from 'lodash';

const statSides = ['both', 'home', 'away'];

let thisTournamentOrAllTournaments = (tournament, event) => {
    if (tournament.countryId === 11) return [];
    // international
    else return [tournament.id];
};

let thisSeasonOrAllSeasons = (tournament, event) => {
    if (tournament.countryId === 11) return [];
    // international
    else return [event.tournamentId]; // seasonIds
};

let seasonFormForTeam = (tournament, season, event, teamSide) =>
    statSides.map(side => ({
        groupTitle: `Season Form ${event.homeShortName} in ${side === 'both' ? 'home+away' : side} matches`,
        name: 'TeamSeasonFormSMWidget',
        groupKey: `form-${event.homeId}-${side}`,
        props: {
            teamId: _.get(event, `${teamSide}Id`),
            teamSide: side,
            ttIds: thisTournamentOrAllTournaments(tournament, event),
            seasonIds: thisSeasonOrAllSeasons(tournament, event),
            Xmatches: 30
        }
    }));

let seasonWLMarginForTeam = (tournament, season, event, teamSide) =>
    statSides.map(side => ({
        groupTitle: `Season Form ${event.homeShortName} in ${side === 'both' ? 'home+away' : side} matches`,
        name: 'TeamSeasonWLMarginSMWidget',
        groupKey: `wlm-${event.homeId}-${side}`,
        props: {
            teamId: _.get(event, `${teamSide}Id`),
            teamSide: side,
            ttIds: thisTournamentOrAllTournaments(tournament, event),
            seasonIds: thisSeasonOrAllSeasons(tournament, event),
            Xmatches: 30
        }
    }));

let seasonH2HForTeam = (tournament, season, event, teamSide) =>
    statSides.map(side => ({
        groupTitle: `HT/FT stats ${event.homeShortName} in ${side === 'both' ? 'home+away' : side} matches`,
        name: 'TeamSeasonH2HSMWidget',
        groupKey: `form-${event.homeId}-${side}`,
        props: {
            teamId: _.get(event, `${teamSide}Id`),
            typeStage: 'top',
            teamSide: side,
            ttIds: thisTournamentOrAllTournaments(tournament, event),
            seasonIds: thisSeasonOrAllSeasons(tournament, event),
            Xmatches: 30
        }
    }));

let seasonAverageGoals = (tournament, season, event, teamSide) =>
    statSides.map(side => ({
        groupTitle: `Average goals ${event.homeShortName} in ${side === 'both' ? 'home+away' : side} matches`,
        name: 'TeamSeasonAverageGoalsSMWidget',
        groupKey: `form-${event.homeId}-${side}`,
        props: {
            teamId: _.get(event, `${teamSide}Id`),
            typeStage: 'graphDot',
            teamSide: side,
            ttIds: thisTournamentOrAllTournaments(tournament, event),
            seasonIds: thisSeasonOrAllSeasons(tournament, event),
            Xmatches: 30
        }
    }));

let rest = (tournament, season, event) => [
    {
        groupTitle: `H2H Live ${event.homeShortName}`,
        name: 'TeamSeasonH2HLiveWidget',
        groupKey: `match-live-${event.homeId}`,
        props: {
            teamId: event.homeId,
            eventId: event.eventId,
            allTournaments: true,
            teamSide: 'both'
        }
    },
    {
        groupTitle: `H2H Live ${event.awayShortName}`,
        name: 'TeamSeasonH2HLiveWidget',
        groupKey: `match-live-${event.awayId}`,
        props: {
            teamId: event.awayId,
            eventId: event.eventId,
            allTournaments: true,
            teamSide: 'both'
        }
    },
    {
        name: 'TeamSeasonH2HStatsSMWidget',
        props: {
            eventId: event.eventId
        }
    }
];

// return Promise.resolve([

//     {
//         groupTitle: `H2H Live ${event.homeShortName}`,
//         name: 'TeamSeasonH2HLiveWidget',
//         groupKey: `match-live-${event.homeId}`,
//         props: {
//             'data-team-id': event.homeId,
//             'data-event-id': event.eventId,
//             'data-all-tournaments': false,
//             'data-team-side': 'both'
//         },
//         key: `live-home-${event.homeId}`
//     },
//     {
//         groupTitle: `H2H Live ${event.awayShortName}`,
//         name: 'TeamSeasonH2HLiveWidget',
//         groupKey: `match-live-${event.awayId}`,
//         props: {
//             'data-team-id': event.awayId,
//             'data-event-id': event.eventId,
//             'data-all-tournaments': false,
//             'data-team-side': 'both'
//         },
//         key: `live-away-${event.awayId}`
//     },
//     {
//         name: 'TeamSeasonH2HStatsSMWidget',
//         props: {
//             'data-event-id': event.eventId
//         },
//         key: `stats-TeamSeasonH2HStatsSMWidget`
//     }
// ]);

class EventSMB extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    componentDidMount = () => {};

    state = {};

    render() {
        const user = this.context.user;
        let {
            event,
            tournament,
            season,
            params: { eventId, tournamentId }
        } = this.props;

        return (
            <div>
                {['home', 'away'].map(side => (
                    <SMStream
                        key={`sf-${side}`}
                        smWidgets={rest(tournament, season, event, side)}
                        title={`Form ${_.get(event, `${side}Name`)}`}
                    />
                ))}
                {['home', 'away'].map(side => (
                    <SMStream
                        key={`sf-${side}`}
                        smWidgets={seasonFormForTeam(tournament, season, event, side)}
                        title={`Form ${_.get(event, `${side}Name`)}`}
                    />
                ))}
                {['home', 'away'].map(side => (
                    <SMStream
                        key={`sf-${side}`}
                        smWidgets={seasonWLMarginForTeam(tournament, season, event, side)}
                        title={`Win/Lost Margin ${_.get(event, `${side}Name`)}`}
                    />
                ))}
                {['home', 'away'].map(side => (
                    <SMStream
                        key={`sf-${side}`}
                        smWidgets={seasonH2HForTeam(tournament, season, event, side)}
                        title={`HT/FT stats ${_.get(event, `${side}Name`)}`}
                    />
                ))}
                {['home', 'away'].map(side => (
                    <SMStream
                        key={`sf-${side}`}
                        smWidgets={seasonAverageGoals(tournament, season, event, side)}
                        title={`Goals ${_.get(event, `${side}Name`)}`}
                    />
                ))}

                {/* <EventStatsSMStream key={'stats_' + eventId} eventId={eventId} /> */}
                {/* <TournamentBasicSMStream key={eventId + 't'} tournamentId={tournamentId} eventId={eventId} /> */}
            </div>
        );
    }
}

export default connect(state => ({ ...state.smBrowser }))(EventSMB);



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/pages/event/EventStatsSMB.js
 **/